module.exports = __webpack_public_path__ + "assets/img/tenents-icon.e6458098.svg";